import { render, staticRenderFns } from "./salesData.vue?vue&type=template&id=8cf6b6b8"
import script from "./salesData.vue?vue&type=script&lang=js"
export * from "./salesData.vue?vue&type=script&lang=js"
import style0 from "./salesData.vue?vue&type=style&index=0&id=8cf6b6b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports